// src/main.js
import { createApp, reactive } from 'vue';
import App from './App.vue';
import router from './router';

// Tạo một trạng thái reactive toàn cục cho audio player
const audioState = reactive({
  story: null,
  currentChapterIndex: -1,
  // Hàm để thiết lập bài hát hiện tại, được gọi từ các component
  setTrack(story, chapterIndex) {
    // Nếu truyện không đổi và chương cũng không đổi, không làm gì cả
    if (this.story?.slug === story.slug && this.currentChapterIndex === chapterIndex) {
        return;
    }

    // Nếu là một câu chuyện mới, tạm thời reset chapter index
    // để đảm bảo watcher trong AudioPlayer sẽ luôn được kích hoạt
    if (this.story?.slug !== story.slug) {
        this.currentChapterIndex = -1;
    }

    // Cập nhật truyện và chương hiện tại
    this.story = story;
    this.currentChapterIndex = chapterIndex;
  },
});

const app = createApp(App);

// Cung cấp audio state cho tất cả các component con
app.provide('audioState', audioState);

app.use(router);

app.mount('#app');
